// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileOfficePptIconSignature {
  Element: SVGSVGElement;
}

export const FileOfficePptIcon: TOC<FileOfficePptIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 3H15V7H19V8H21V5.586L16.414 1H5C3.897 1 3 1.898 3 3V8H5V3ZM5 21V20H3V21C3 22.103 3.897 23 5 23H19C20.103 23 21 22.103 21 21V20H19V21H5ZM16 12V10H22V12H20V18H18V12H16ZM4 16H5C6.654 16 8 14.654 8 13C8 11.346 6.654 10 5 10H2V18H4V16ZM5 12H4V14H5C5.551 14 6 13.552 6 13C6 12.448 5.551 12 5 12ZM9 10V18H11V16H12C13.654 16 15 14.654 15 13C15 11.346 13.654 10 12 10H9ZM12 14C12.551 14 13 13.552 13 13C13 12.448 12.551 12 12 12H11V14H12Z"/>
</svg>
</template>;